export const SidebarContent = {
  comingSoon: 'More features coming soon...',
  loginText: 'Logged in to',
  logoutButton: 'Log Out',
  helpAndSupport: 'Help & Support',
  navigateToMobileApp: 'Do more with SmartBiz app',
  googlePlayScanner: 'Scan below to download the app',
  scannerTootTipContent: 'Scan this QR code to download the app',
  mobileIconToolTipContent: 'This feature is currently only available on the Mobile App',
  newTag: 'NEW',
  returnsSettings: 'Returns',
  config: 'config',
  allOrders: 'All Orders',
  returnsConfig: 'RETURNS_CONFIG',
  orders: 'orders',
  returns: 'returns',
  storeConfiguration: 'Store Configuration',
  settings: 'Settings',
  growth: 'Growth',
  trustMarkers: 'Trust Markers',
  manageReturns: 'Manage Returns',
  instagramFeedText: 'Instagram Feed',
  instagramFeedPath: 'instagram-feed',
  sellUsingWhatsappText: 'Sell using Whatsapp',
  sellUsingWhatsappPath: 'sell-using-whatsapp',
  trustBadgesText: 'Trust Badges',
  trustBadgesPath: 'trust-badges',
};
 
export const StoreConfigurationPaths = ["Store Configuration", "store-appearance", "google-analytics"];

export const SettingPaths = ["Settings", "settings", "profile", "custom-domain", "delivery-settings","config","payments", "store-timings", "social-media", "store-policies", "user-management"];

export const GrowthPaths = ["Growth", "performance-marketing","offers","sell-using-videos", "seo", "marketing-automation"];

export const CatalogPaths = ["Catalog", "products","categories","collections"];

export const AnalyticsPaths = ["Analytics",  "sales-and-orders", "traffic", "operations", "order", "offer", "sales", "return", "customer-details", "customer-segments", "reports"];

export const OrderPaths = ["Orders", "","returns"];

export const ReviewsPaths = ["Reviews", "manage"];

export const ModulePaths = [
  StoreConfigurationPaths,
  SettingPaths,
  GrowthPaths,
  AnalyticsPaths,
  CatalogPaths,
  OrderPaths,
  ReviewsPaths,
];

export const parentPaths = ["home"];
